import React from 'react';
import { Pill as TPill } from '../../../domain/status';
import { useDrag } from 'react-dnd';
import { DragTargetTypes } from '../Planner/DayTime';
import { createUseStyles } from 'react-jss';
import clsx from 'clsx';

const useStyles = createUseStyles({
    pill: {
    },
    pillImg: {
        display: 'block',
        width: 40,
        height: 40,
        transition: 'transform 0.1s ease-in-out',
        cursor: 'grab',
        '&:hover': {
            transform: 'scale(1.2)',
        },
    },
    pillDragging: {
        opacity: 0.2,
        cursor: 'grabbing',
    },
});

export type DragOrigin = 'box' | number;

export type DraggablePill = {
    pill: TPill;
    origin: DragOrigin;
}

interface IPillProps {
    pill: TPill;
    origin: DragOrigin;
}

export const Pill: React.FunctionComponent<IPillProps> = props => {
    const [ { isDragging }, drag ] = useDrag<DraggablePill, unknown, {
        isDragging: boolean,
        handlerId: unknown,
    }>(() => ({
        type: DragTargetTypes.PILL,
        item: { pill: props.pill, origin: props.origin },
        collect: monitor => ({
            isDragging: monitor.isDragging(),
            handlerId: monitor.getHandlerId(),
        }),
    }));

    const styles = useStyles();

    return (
        <div style={{ fontSize: '3rem' }} ref={drag} className={clsx(styles.pill, isDragging && styles.pillDragging)}>
            {props.pill.icon ? <img className={styles.pillImg} src={props.pill.icon} alt=""/> : '💊'}
        </div>
    );
};
